module.exports = __webpack_public_path__ + "static/media/cc_icon-arc.e35f7875.svg";